import React from "react";
import { JobsTable, AssignPicker, CostLines, EscalationLadder, QuoteCompare, ProjectBoard, ScheduleGrid, ContractsCalendar, PropertiesList, WebhookFeed } from "./core";
import { PWASnapshot, LiveMap, LiveTracker, ClientPortalDash, ClientRequests, ClientInvoices, RoutePlanner, WhatsAppInbox } from "./portals";
import { SupplierPortalDash, SupplierMobile, BulkInvite, ComplianceMatrix } from "./suppliers";
import { InvoiceBuilder, AssetCard, JobSheetForm, ReportsDash, StaffPresence, BrandingPanel, FileHub } from "./management";
import { AIMatch, Reassign, AIDraft } from "./intelligence";
import { TagScan, TagSheet, RAMSDoc, RAMSBuilder, ToolboxTalks, TalkDeliver, EmailInbox, EmailTriage, ComplianceCalendar, HSLibrary, HSCopy, HSShare } from "./safety";
import { Portfolio, PropertyHub, Accounts, BankRec, VATReturn, Marketplace, QuoteRequest, Listing } from "./business";

export const MOCKUPS = {
  jobs: JobsTable,
  assign: AssignPicker,
  costlines: CostLines,
  escalation: EscalationLadder,
  quotecompare: QuoteCompare,
  projects: ProjectBoard,
  schedule: ScheduleGrid,
  contracts: ContractsCalendar,
  properties: PropertiesList,
  webhooks: WebhookFeed,
  pwa: PWASnapshot,
  livemap: LiveMap,
  livetracker: LiveTracker,
  clientportal: ClientPortalDash,
  clientrequests: ClientRequests,
  clientinvoices: ClientInvoices,
  route: RoutePlanner,
  whatsapp: WhatsAppInbox,
  supplierportal: SupplierPortalDash,
  suppliermobile: SupplierMobile,
  bulkinvite: BulkInvite,
  compliancematrix: ComplianceMatrix,
  compliancehub: (p) => <ComplianceMatrix title="Compliance Hub" hub {...p} />,
  invoice: InvoiceBuilder,
  asset: AssetCard,
  jobsheet: JobSheetForm,
  reports: ReportsDash,
  presence: StaffPresence,
  branding: BrandingPanel,
  files: FileHub,
  aimatch: AIMatch,
  reassign: Reassign,
  aidraft: AIDraft,
  tagscan: TagScan,
  tagsheet: TagSheet,
  rams: RAMSDoc,
  ramsbuilder: RAMSBuilder,
  toolbox: ToolboxTalks,
  talkdeliver: TalkDeliver,
  emailinbox: EmailInbox,
  emailtriage: EmailTriage,
  compliancecalendar: ComplianceCalendar,
  portfolio: Portfolio,
  propertyhub: PropertyHub,
  accounts: Accounts,
  bankrec: BankRec,
  vatreturn: VATReturn,
  marketplace: Marketplace,
  quoterequest: QuoteRequest,
  listing: Listing,
  hslibrary: HSLibrary,
  hscopy: HSCopy,
  hsshare: HSShare,
};

// Mockups that render as a phone rather than inside a browser frame.
export const PHONE_MOCKUPS = new Set(["pwa", "livetracker", "suppliermobile", "tagscan", "talkdeliver"]);

export const Mockup = ({ name, ...props }) => {
  const C = MOCKUPS[name];
  return C ? <C {...props} /> : null;
};
